import { Query, useIsFetching, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";

export const useMetricsRefresh = () => {
  const queryClient = useQueryClient();
  const fetchingMetrics = useIsFetching({
    queryKey: ["metrics"],
    exact: false,
  });
  const [query, setQuery] = useState<Query | undefined>();
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    if (!fetchingMetrics) {
      setRefreshing(false);

      setQuery(
        // Remove getting a not exact matching query here. Its hacky and discouraged.
        // check: https://github.com/TanStack/query/discussions/6166
        queryClient
          .getQueryCache()
          .find({ queryKey: ["metrics"], exact: false, type: "active" }),
      );
    }
  }, [fetchingMetrics, queryClient]);

  const refresh = () => {
    setRefreshing(true);

    queryClient.invalidateQueries({
      queryKey: ["metrics"],
    });
  };

  return {
    refreshing,
    refresh,
    dataUpdatedAt: query?.state.dataUpdatedAt,
  };
};
